import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from 'react-router-dom';
import Symbol from '../../common/mobile/Symbol.js';


const Aside = () => {
   
    const [activeCategory, setActiveCategory] = useState("home");
    const [systems, setSystems] = useState([]);
    const [sociallink, setSociallink] = useState([]);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const CloseTabBar = () => {
        
            const aside = document.querySelector('.sidebar');
            aside.classList.remove('main-nav-open'); 
      };
      const handleCategoryClick = (type) => {
        // If the clicked category is the active one, reset it to null
        if (activeCategory === type) {
          setActiveCategory(null);
        } else {
          // Otherwise, set the clicked category as active
          setActiveCategory(type);
        }
      };
      
    const fetchSocial = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/sociallink`);
            const data = await response.json();
            if (response.ok) {
                setSociallink(data);
               
            } else {
                setError(data);
                
            }
        } catch (error) {
            console.error('Error fetching social links:', error);
            setError('An unexpected error occurred while fetching social links');
        }
    };
    useEffect(() => {
        fetchSocial();
    }, []); 
    // Menu data
const menuData = [
    { title: "Home", icon: "icon-home_36eb0cd1", type: "home", link: "/" },
    { title: "Sports", icon: "icon-sports_1cffa65d", type: "SPORTS", link: "/exchange" },
    { title: "Casino", icon: "icon-live_ac757f68", type: "LIVE" },
    { title: "Slot", icon: "icon-rng_1ce51696", type: "SLOT" },
    { title: "Table", icon: "icon-table_b56addc3", type: "TABLE" },
    { title: "Crash", icon: "icon-crush_a699c529", type: "EGAME" },
    { title: "Fishing", icon: "icon-fish_f1f386cf", type: "FH" },
    { title: "Lottery", icon: "icon-lott_773c2cb1", type: "LOTTO" },
];

const promotionData = [
    { title: "Promotions", icon: "icon-promotion.png", link: "promotions" },
    { title: "Referral Program", icon: "icon-referral.png", link: "refrrel-program" },
    { title: "VIP", icon: "icon-vip.png", link: "/" },
];
const origin = window.location.origin
  .replace(/^https?:\/\/(www\.)?/, '');  // Removes 'http://', 'https://', and 'www.'


const supportData = [
    { title: "Affiliate", icon: "", link: `https://affilaite.${origin}` },
    { title: "24/7 LiveChat", icon: "menu-cs_a0827470", description: "Provides 24/7 Quality service", link: sociallink[0]?.whatsapp ? `${sociallink[0].whatsapp}` : '#', },
    
];

const providerData = [{ platform: "icon-all-provider.svg" }];

const sportsOptions = [
    { name: "Exchange", icon: "icon-exchange.svg", link: "/exchange" },
    { name: "I-Sports", icon: "icon-sportbook.svg" },
    { name: "E1Sports", icon: "icon-awcme1sport.svg" },
    { name: "Horsebook", icon: "icon-horsebook.svg" },
    { name: "Virtual", icon: "icon-virtual.svg" },
    { name: "Kabaddi", icon: "icon-kabaddi.svg" },
    { name: "Fantasy", icon: "icon-powerelevenv2.svg" },
    { name: "SBO Sports", icon: "icon-sbov2.svg" },
];

const [providers, setProviders] = useState(providerData);

    

    useEffect(() => {
        const selectedMenu = menuData.find(item => item.type === activeCategory);
        if (selectedMenu && activeCategory !== "home") {
            fetchSystems(selectedMenu.type);
        } else {
            setSystems([]);
            setProviders(providerData);
        }
    }, [activeCategory]);
    const handleCasinoClick = (system, type) => {
        const selectedMenu = menuData.find(item => item.type === type);
        if (selectedMenu) {
            navigate('/games', { state: { system, type: selectedMenu.type, title: selectedMenu.title } });
        } else {
            console.error('Selected menu item not found');
        }
    };
    

    const fetchSystems = async (type) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/get-system?type=${type}`);
            const data = await response.json();
            if (response.ok) {
                setSystems(data.systems || []);
                fetchProviders(data.systems);
            } else {
                setError(data.message || 'Failed to fetch systems');
            }
        } catch (error) {
            console.error('Error fetching systems:', error);
            setError('An unexpected error occurred while fetching systems');
        }
    };

    const fetchProviders = async (systems) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/get-provider?system=${JSON.stringify(systems)}`);
            const data = await response.json();
            if (response.ok) {
                setProviders([{ platform: "icon-all-provider.svg" }, ...(data.data || [])]);
                console.log('Providers fetched:', data.data);
            } else {
                setError(data.message || 'Failed to fetch providers');
            }
        } catch (error) {
            console.error('Error fetching providers:', error);
            setError('An unexpected error occurred while fetching providers');
        }
    };
     const [sliders, setSliders] = useState([]);
        const [currentSlide, setCurrentSlide] = useState(0);
        const swiperRef = useRef(null);
    
        useEffect(() => {
            const fetchSliders = async () => {
                try {
                    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/sliders`);
                    const data = await response.json();
                    const activeMainSliders = data.filter(slider => slider.status === 'active' && slider.slider_type === 'Mobile');
                    setSliders(activeMainSliders);
                } catch (error) {
                    console.error('Error fetching sliders:', error);
                }
            };
    
            fetchSliders();
        }, []);
    
        useEffect(() => {
            const interval = setInterval(() => {
                setCurrentSlide((prevSlide) => (prevSlide + 1) % sliders.length);
            }, 6000); // Auto change slide every 6 seconds
    
            // Cleanup interval on component unmount
            return () => clearInterval(interval);
        }, [sliders.length]);
    
        const handleSlideChange = (index) => {
            setCurrentSlide(index);
        };
    
        const getTransformStyle = (index) => {
          const screenWidth = window.innerWidth; // Get current screen width
          const offset = index * screenWidth; // Adjust offset based on screen width
          return `translate3d(-${offset-70}px, 0px, 0px)`;
      };

    return (
        <div className="sidebar">
            <Symbol/>
        <div className="left-side-menu">
          <svg onClick={CloseTabBar} className="am-icon am-icon-icon-close_c26cd901 am-icon-md close-sidebar">
            <use xlinkHref="#icon-close_c26cd901" /></svg>
          <div className="home-banner">
            <div className="swiper-container swiper-container-initialized swiper-container-horizontal" id="home-swiper-container">
              <div className="swiper-wrapper" style={{
                        transitionDuration: '0ms',
                        transform: getTransformStyle(currentSlide), 
                    }}>
                      {sliders.map((slider, index) => (
                <div key={slider.id} className="swiper-slide swiper-slide-duplicate" data-swiper-slide-index={index}>
                  <img src={`${process.env.REACT_APP_API_URL}/storage/${slider.thubmnail}`} alt={slider.alt_text || 'Slider Image'} />
                </div>
                ))}
                
              </div>
              <div className="swiper-pagination swiper-pagination-clickable swiper-pagination-bullets">
              {sliders.map((_, index) => (
                <span className={`swiper-pagination-bullet ${currentSlide === index ? 'swiper-pagination-bullet-active' : ''}`} onClick={() => handleSlideChange(index)} tabIndex={0} role="button"  aria-label={`Go to slide ${index + 1}`} />
              ))}
              </div>
              <span className="swiper-notification" aria-live="assertive" aria-atomic="true" />
            </div>
          </div>
          <div className="side-menu-content hide-scrollbar">
          <div className="side-game-nav">
          {menuData.map((item, index) => (
  <React.Fragment key={index}>
    {/* Render side-game-item */}
    <div
      className={`side-game-item ${activeCategory === item.type ? "on" : ""}`}
    >
      <svg className={`am-icon am-icon-${item.icon} am-icon-md`}>
        <use xlinkHref={`#${item.icon}`} />
      </svg>
      <a
        onClick={() => handleCategoryClick(item.type)}
        href={item.link || "#"}
      >
        {item.title}
        
      </a>
      {!["home", "SPORTS"].includes(item.type) && (
    <svg onClick={() => handleCategoryClick(item.type)} className="am-icon am-icon-side-arrow-down_7d99edc7 am-icon-md arrow-down">
      <use xlinkHref="#side-arrow-down_7d99edc7" />
    </svg>
  )}
    </div>

    {/* Conditionally render vendors only after the active side-game-item, excluding "home" and "SPORTS" */}
    {activeCategory === item.type && !["home", "SPORTS"].includes(item.type) && (
      <div className="side-game-vendors">
        {providers.map((provider, index) => (
          <div key={index} className="side-menu-vendor">
            <div onClick={() => handleCasinoClick(provider.platform, activeCategory )} className="vendor-item">
              {provider.platform.endsWith(".svg") ? (
                <img
                  src={`./icons/${provider.platform}`}
                  alt={provider.name}
                />
              ) : (
                <img
                  src={`./icons/platform/${provider.platform}.png`}
                  alt={provider.name}
                />
              )}
              <span className="side-vendor-name">
                {provider.platform.replace("icon-", "").replace("-", " ")}
              </span>
            </div>
          </div>
        ))}
      </div>
    )}
  </React.Fragment>
))}


  {/* Promo Section */}
  <div className="promo-invite">
    <div className="side-game-item">
      <svg className="am-icon am-icon-icon-promo_d8a90244 am-icon-md">
        <use xlinkHref="#icon-promo_d8a90244" />
      </svg>
      <span>
        <Link to={"promotions"}>Promotion</Link>
      </span>
    </div>
  </div>
</div>



            <div className="channel-list">
            {supportData.map((item, index) => (
              <div className="channel-item">
                <svg className={`am-icon am-icon-${item.icon} am-icon-md`}>
                  <use xlinkHref={`#${item.icon}`} /></svg>
                  <Link key={index} to={item.link}>{item.title}</Link>
               
              </div>
            ))}
              <div className="side-menu-lang">
                <div className="language-container">
                  <div className="lang-select">
                    <img className="language-icon" src="https://images.3953049.com//TCG_PROD_IMAGES/COUNTRY_FLAG/CIRCLE/BD.svg" alt="" /><span className="language-name">English</span>
                    <svg className="am-icon am-icon-arrow-down_cee2e8d6 am-icon-md arrow"><use xlinkHref="#arrow-down_cee2e8d6" /></svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div onClick={CloseTabBar} className="sidebar-mask" />
      </div>
    );
};

export default Aside;
